<template>
  <ContentWrap>
    <el-form :model="query" inline>
      <el-form-item label="上游编码"><el-input v-model="query.upstreamCode" clearable class="!w-160px" /></el-form-item>
      <el-form-item label="下游编码"><el-input v-model="query.downstreamCode" clearable class="!w-160px" /></el-form-item>
      <el-form-item label="关系">
        <el-select v-model="query.relationType" clearable class="!w-140px">
          <el-option label="上下游" :value="1" />
          <el-option label="互补" :value="2" />
          <el-option label="同业" :value="3" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button v-hasPermi="['bosscircle:industry-mapping:create']" @click="openForm()">新增</el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column prop="id" label="编号" width="90" />
      <el-table-column prop="upstreamCode" label="上游编码" min-width="140" />
      <el-table-column prop="downstreamCode" label="下游编码" min-width="140" />
      <el-table-column label="关系" width="100">
        <template #default="scope">{{ relationLabel(scope.row.relationType) }}</template>
      </el-table-column>
      <el-table-column prop="strength" label="强度" width="90" />
      <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip />
      <el-table-column label="操作" width="150" fixed="right">
        <template #default="scope">
          <el-button v-hasPermi="['bosscircle:industry-mapping:update']" link type="primary" @click="openForm(scope.row)">修改</el-button>
          <el-button v-hasPermi="['bosscircle:industry-mapping:delete']" link type="danger" @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:page="query.pageNo"
      v-model:limit="query.pageSize"
      :total="total"
      @pagination="load"
    />
  </ContentWrap>

  <Dialog v-model="formVisible" :title="form.id ? '修改行业映射' : '新增行业映射'" width="520px">
    <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="上游编码" prop="upstreamCode"><el-input v-model="form.upstreamCode" maxlength="32" /></el-form-item>
      <el-form-item label="下游编码" prop="downstreamCode"><el-input v-model="form.downstreamCode" maxlength="32" /></el-form-item>
      <el-form-item label="关系类型" prop="relationType">
        <el-radio-group v-model="form.relationType">
          <el-radio :value="1">上下游</el-radio>
          <el-radio :value="2">互补</el-radio>
          <el-radio :value="3">同业</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="强度" prop="strength"><el-input-number v-model="form.strength" :min="0" :max="100" /></el-form-item>
      <el-form-item label="备注"><el-input v-model="form.remark" maxlength="255" /></el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="submit">保存</el-button>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import * as MappingApi from '@/api/business/industryMapping'

defineOptions({ name: 'BossCircleIndustryMapping' })

const message = useMessage()
const loading = ref(false)
const list = ref<any[]>([])
const total = ref(0)
const formVisible = ref(false)
const formRef = ref()
const query = reactive({
  pageNo: 1,
  pageSize: 10,
  upstreamCode: '',
  downstreamCode: '',
  relationType: undefined as number | undefined
})
const form = reactive<any>({
  id: undefined,
  upstreamCode: '',
  downstreamCode: '',
  relationType: 1,
  strength: 50,
  remark: ''
})
const rules = {
  upstreamCode: [{ required: true, message: '请输入上游编码', trigger: 'blur' }],
  downstreamCode: [{ required: true, message: '请输入下游编码', trigger: 'blur' }],
  relationType: [{ required: true, message: '请选择关系类型', trigger: 'change' }]
}

const relationLabel = (type?: number) => {
  if (type === 1) return '上下游'
  if (type === 2) return '互补'
  if (type === 3) return '同业'
  return '-'
}

const load = async () => {
  loading.value = true
  try {
    const data = await MappingApi.getIndustryMappingPage(query)
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}

const search = () => {
  query.pageNo = 1
  load()
}

const openForm = (row?: any) => {
  Object.assign(
    form,
    row || {
      id: undefined,
      upstreamCode: '',
      downstreamCode: '',
      relationType: 1,
      strength: 50,
      remark: ''
    }
  )
  formVisible.value = true
}

const submit = async () => {
  await formRef.value.validate()
  if (form.id) await MappingApi.updateIndustryMapping(form)
  else await MappingApi.createIndustryMapping(form)
  message.success('保存成功')
  formVisible.value = false
  await load()
}

const remove = async (row: any) => {
  await message.delConfirm()
  await MappingApi.deleteIndustryMapping(row.id)
  message.success('删除成功')
  await load()
}

onMounted(load)
</script>
